module.exports = __webpack_public_path__ + "static/img/exploit13.f3a09dc5.png";